import { useDispatch } from 'react-redux';
import { UserTeamAccess } from 'types';
import {
	userTeamAccessVerify,
	userTeamAccessVerifyRejected,
	userTeamAccessVerifyResolved,
} from '../../../actions/userTeamAccess.actions';
import { useDispatchForgeLogout } from '../hooks/useDispatchForgeLogout';
import { retriedUserTeamAccessVerification } from '../../../services';

/**
 * Hook to enable user access verification in case of context failure
 */
export default function useVerifyUserAccess() {
	const dispatch = useDispatch();
	const dispatchForgeLogout = useDispatchForgeLogout();

	const handleFailedInitialization = async () => {
		const result = await performUserAccessVerification();
		if (result) {
			displayUserAccessDialog(result);
		} else {
			userTeamAccessRejected();
			dispatchForgeLogout();
		}
	};

	const performUserAccessVerification = async () => {
		dispatch(userTeamAccessVerify());
		return retriedUserTeamAccessVerification();
	};

	const displayUserAccessDialog = (userTeamAccess: UserTeamAccess) => {
		dispatch(userTeamAccessVerifyResolved(userTeamAccess));
	};

	const userTeamAccessRejected = () => {
		dispatch(userTeamAccessVerifyRejected());
	};

	return {
		handleFailedInitialization,
		performUserAccessVerification,
		displayUserAccessDialog,
		userTeamAccessRejected,
	};
}
